import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireSeedrandom } from '../node_modules/.pnpm/seedrandom@3.0.5/node_modules/seedrandom/index.js';

var seedrandomExports = requireSeedrandom();
const seedrandom = /*@__PURE__*/getDefaultExportFromCjs(seedrandomExports);

export { seedrandom as default };
//# sourceMappingURL=index5.js.map
